import { render, staticRenderFns } from "./ProjectEditView.vue?vue&type=template&id=6996642c&scoped=true"
import script from "./ProjectEditView.vue?vue&type=script&lang=ts"
export * from "./ProjectEditView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996642c",
  null
  
)

export default component.exports